import HttpClient from "./http_client";


export const toQueryString = obj => {
    if (obj == null) return "";
    let str = [];
    for (let p in obj) {
        if (obj[p] != null) {
            str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
        }
    }
    return str.join("&");
};


// 请求拦截
HttpClient.prototype.request = function (option) {
    option.url = `/${option.url}`;
    option.headers = {
        "Content-Typ": "multipart/form-data"
    }
    if (option.method === "POST") {
        option['data'] = Object.assign({
            token: localStorage.token
        }, option['data'])
        let formData = new FormData()
        Object.keys(option['data']).map(item => {
            formData.append(item, option.data[item])
        })
        option['data'] = formData
    }
}

// 响应拦截
HttpClient.prototype.response = function (res) {
    let data = JSON.parse(res)
    return Promise.resolve(data)
    // if(data.success){
    //     localStorage.token = data._token
    //     setUserInfo(data)
    //     return Promise.resolve({...data})
    // }else{
    //     return Promise.reject(data)
    // }
}
// 错误响应拦截
HttpClient.prototype.responseError = function (res) {
    return Promise.reject(res)
    // let data = JSON.parse(res)
    // if(data.success){
    //     localStorage.token = data._token
    //     setUserInfo(data)
    //     return Promise.resolve({...data})
    // }else{
    //     return Promise.reject(data)
    // }
}

const chaim = new HttpClient()
const watch = new HttpClient()
const follow = new HttpClient()
const topic = new HttpClient()

export {
    watch,
    follow,
    topic
}
